"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRadiansFromDegrees = getRadiansFromDegrees;
exports.transformDimensionWithRotation = transformDimensionWithRotation;
exports.getMax = getMax;
/**
 * Converts degrees to radians.
 * @param degrees Number of rotational degrees.
 * @returns Radial length calculated from provided degrees.
 */
function getRadiansFromDegrees(degrees) {
    return (degrees * Math.PI) / 180;
}
/**
 * Transforms box dimensions via a provided number of rotational degrees. Calculates new bounding box dimensions
 * required to contain the original rotated box.
 * @param originalDimensions Dimensions of the original box.
 * @param rotation Number of degrees to rotate the box.
 * @returns Box dimensions for space required to contain original rotated box.
 */
function transformDimensionWithRotation(originalDimensions, rotation) {
    const { width, height } = originalDimensions;
    const rotationInRadians = getRadiansFromDegrees(rotation);
    return {
        height: Math.abs(Math.sin(rotationInRadians) * width) + Math.abs(Math.cos(rotationInRadians) * height),
        width: Math.abs(Math.cos(rotationInRadians) * width) + Math.abs(Math.sin(rotationInRadians) * height)
    };
}
/**
 * Computes the maximum value of `values`. If `values` is empty, `null`, or `undefined`, then `undefined` is returned.
 * @param values The collection of values to iterate over.
 * @returns Returns the maximum value.
 */
function getMax(values) {
    if (!(values === null || values === void 0 ? void 0 : values.length)) {
        return undefined;
    }
    let currentMax = 0;
    for (const value of values) {
        if (value > currentMax) {
            currentMax = value;
        }
    }
    return currentMax;
}
//# sourceMappingURL=lib.js.map